<template>
    <div class="of-content1-tutorial" >
        <div class="t-content">
            <h3 class="t-content-title" v-html="tutorial.title" ></h3>
            <p class="t-content-text" v-html="tutorial.text" ></p>
            <div
                class="t-button"
                @click="pageRedirect(tutorial.button.link)"
                v-html="tutorial.button.text"
                data-ba-i="fc-c1-tutorial"
            ></div>
        </div>
        <div class="t-main-svg">
            <img :src="tutorial.mainSvg" alt="" srcset="">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tutorial',
        props: ['view'],
        data(){
            return {
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube-tutorial.svg',
                title: 'Tutorial',
                text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                button: {
                    text: "Learn more",
                    link: "#"
                }
            }
        },
        methods: {
            pageRedirect: function (link){
                window.open(link, '_blank')
            }
        },
        computed: {
            tutorial: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){

        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    .of-content1-tutorial{
        font: inherit;
        border-radius: 4px;
        background-color: $of-color3;
        box-sizing: border-box;

        display: grid;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: stretch;
        justify-content: start;
        align-content: stretch;

        .t-main-svg{
            font: inherit;
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 6;
            grid-column-end: 11;

            padding: 3em 1em 0 2em; /* 30px 10px 0 20px */
            img{
                width: 100%;
                height: auto;
                max-height: 100%;
            }
        }
        .t-content{
            font: inherit;
            text-align: left;

            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 6;

            padding: 3.6em 3.6em 3.6em 2.8em; /* 36px 26px 36px 28px*/

            h3,
            .t-content-title{
                font: inherit;
                font-size: 3em; /* 30px */
                font-family: $of-font1;
                font-weight: 700;
                line-height: 1.2;
                color: $of-color1;

                margin: 0 0 0.4em 0; /* 12px */
            }
            p,
            .t-content-text{
                font: inherit;
                font-size: 1.4em; /* 14px */
                line-height: 1.2;
                margin: 0 0 1.714285714em 0; /*24px */
                color: $of-color2;
            }
            div,
            .t-button {
                font: inherit;
                font-size: 1.4em; /* 14px */
                display: inline-block;
                background: $of-color1;
                padding: 0.714285714em 1.071428571em; /* 10px 15px */
                color: $of-color3;
                border-radius: 4px;
                transition: 1s all ease;
                margin: 0 0 1.857142857em 0; /*26px */
                text-align: center;
                &:hover {
                    cursor: pointer;
                    box-shadow: 0px 0px 7px -2px $of-color1;
                }
            }
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content1-tutorial{
            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;

            .t-main-svg{
                width: 90%;
                grid-row-start: 1;
                grid-row-end: 2;
                grid-column-start: 1;
                grid-column-end: 2;

            }
            .t-content{
                width: 90%;
                padding: 1.75% 0;

                grid-row-start: 2;
                grid-row-end: 3;
                grid-column-start: 1;
                grid-column-end: 2;

                h3,
                .t-content-title{
                    font-size: 3.6em; /* 36px */
                }
                p,
                .t-content-text{
                    font-size: 1.68em; /* 16.8px */
                }
                .t-button {
                    display: block;
                    font-size: 1.92em; /* 19.2px */
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-1/tutorial.vue